import React from "react";
import { useTheme } from "@/context/ThemeContext";
import mark from "@/assets/decide-mark.png";

// Matches the MOBILE app Logo (src/components/Logo.tsx) exactly:
// the locked master symbol PNG + a Manrope "DECIDE" wordmark beside it.
// Light: green symbol + green wordmark (#1F5C3F). Dark: symbol stays green,
// only the wordmark text turns white. Symbol artwork is never redrawn.
const MARK_ASPECT = 1353 / 967; // decide-mark.png width/height

const SIZES = {
  sm: { text: 18, track: 0.34, mark: 22 },
  md: { text: 20, track: 0.38, mark: 26 },
  lg: { text: 30, track: 0.4, mark: 40 },
};

const WORDMARK_GREEN = "#1F5C3F";

export function LogoMark({ px = 24 }) {
  return (
    <img
      src={mark}
      alt="DECIDE"
      draggable={false}
      className="shrink-0 select-none object-contain"
      style={{ width: px * MARK_ASPECT, height: px }}
    />
  );
}

export function Logo({ size = "md", className = "" }) {
  const ctx = useTheme();
  const isDark = ctx?.theme === "dark";
  const s = SIZES[size] || SIZES.md;
  const track = s.text * s.track;
  return (
    <div
      className={`flex items-center gap-2 shrink-0 ${className}`}
      aria-label="DECIDE"
      data-testid="decide-logo"
    >
      <LogoMark px={s.mark} />
      <span
        className="font-semibold leading-none shrink-0 whitespace-nowrap"
        style={{
          fontSize: s.text,
          letterSpacing: track,
          paddingRight: track,
          color: isDark ? "#FFFFFF" : WORDMARK_GREEN,
        }}
      >
        DECIDE
      </span>
    </div>
  );
}
